import React, { useEffect, useState } from 'react'
import { Loading } from '../../components/Loading'
import { ModalMailConfirm } from '../../components/ModalMailConfirm'
import { useFirmaContratada } from '../../hooks/useFirmaContratada'
import { NavDocumentos } from './NavDocumentos'

export const  IndexFirma = () => {


  const {firmaContratada} =  useFirmaContratada()


  const [enrolado, setEnrolado] = useState(false)


  useEffect(() => {
 
    const emailok = localStorage.getItem('emailok')

    if(emailok === 'N' ){
      return null
    }

    setEnrolado(true)


  }, [])



    if( firmaContratada === 'checking') {
      return <div className='contenedorNoActivo'>

                <Loading/> 


              </div>
    }

  // firmaContratada === 'check' &&  return <Loading/> 


  return (

    
    <>



   
     
   
    {
      enrolado && firmaContratada !== 'N' ?  <NavDocumentos/> :

      enrolado && firmaContratada === 'N' ? 

      <div className='contenedorNoActivo'>

          <p> Esta opción aún no está activa para su empleador. </p> 

      </div>
      
      :
      
      <div className='contenedorModalMailFirma' >


            <ModalMailConfirm  setEnrolado={setEnrolado}  enrolamiento={'si'} /> 

      </div>
      
      
    }

   
    

  
     

    </>
  )
}
